import dayjs from 'dayjs';

// fetchStatsHistory uses exclusive $gt/$lt bounds; shift a day each side so [startDate, endDate] is inclusive (undefined = unbounded).
export const toInclusiveStatsHistoryRange = (
  startDate?: string,
  endDate?: string,
): { afterDate?: string; beforeDate?: string } => ({
  afterDate: startDate
    ? dayjs(startDate).subtract(1, 'day').format('YYYY-MM-DD')
    : undefined,
  beforeDate: endDate
    ? dayjs(endDate).add(1, 'day').format('YYYY-MM-DD')
    : undefined,
});
